module.exports = __webpack_public_path__ + "img/CLS-P-470.70809a99.svg";